import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_CAMPAIGN_CODE,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_SELECTED_CERTIFICATE,
  CHECKOUT_SET_DELIVERY_CONTACT_PERSON,
  CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE,
  CHECKOUT_SET_ORDER_MARKING,
  CHECKOUT_SET_CUSTOM_NOTE,
  CHECKOUT_SET_PICKING_INSTRUCTIONS,
  CHECKOUT_SET_PACKING_INSTRUCTIONS,
  CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS,
  CHECKOUT_SET_SELECTED_SALES_REP,
  CHECKOUT_SET_IS_VALID_FORM,
  SAVE_CART_MODAL_UPDATE,
  CHECKOUT_SET_ORGANIZATION_USER,
  UPDATE_ORGANIZATION_USER,
  CHECKOUT_SAVE_CART_ON_PURCHASE,
} from '../constants';
import { error as errorReducer } from './Error.reducer';
const defaultState = {
  payload: {
    alternativeAddress: {},
    customerDetails: {},
    selectedCompanyAddressId: null,
    selectedCountry: '',
    discountCode: '',
    orderNote: '',
    isBusinessCustomer: false,
    signUp: false,
    acceptTermsOfCondition: false,
    authenticated: false,
    deliveryMethods: [],
    companyAddresses: [],
    responseUrl: '',
    cancelUrl: '',
    redirectUrl: '',
    selectedCertificateId: '',
    deliveryContactPersonName: '',
    deliveryContactPersonPhoneNumber: '',
    orderMarking: null,
    customNote: null,
    pickingInstruction: null,
    packingInstruction: null,
    transportationInstruction: null,
    selectedSalesRepId: '0',
    selectedTempAddress: {},
    saveCartTitle: '',
    isValidForm: false,
    isOrderHistoryLoading: false,
    organizationUsers: [],
    selectedSavedCartUser: '',
    saveCartOnPurchase: false,
  },
  errors: {},
  result: {},
  isSubmitting: false,
};

export const checkout = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CHECKOUT_SUBMIT_ERROR:
      return {
        ...state,
        isSubmitting: false,
        errors: errorReducer(state.errors, action),
      };
    case CHECKOUT_SUBMIT:
      return {
        ...state,
        ...payload,
      };
    case CHECKOUT_SET_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_ORDER_NOTE:
    case CHECKOUT_SET_PRIVATE_CUSTOMER:
    case CHECKOUT_SET_SIGN_UP:
    case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
    case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
    case CHECKOUT_SET_CAMPAIGN_CODE:
    case CHECKOUT_SET_SELECTED_CERTIFICATE:
    case CHECKOUT_SET_SELECTED_SALES_REP:
    case CHECKOUT_SET_DELIVERY_CONTACT_PERSON:
    case CHECKOUT_SET_SELECTED_DELIVERY_CONTACT_PERSON_PHONE:
    case CHECKOUT_SET_PICKING_INSTRUCTIONS:
    case CHECKOUT_SET_PACKING_INSTRUCTIONS:
    case CHECKOUT_SET_TRANSPORTATION_INSTRUCTIONS:
    case CHECKOUT_SET_ORDER_MARKING:
    case CHECKOUT_SET_CUSTOM_NOTE:
    case CHECKOUT_SET_COUNTRY:
    case CHECKOUT_SET_IS_VALID_FORM:
    case CHECKOUT_SAVE_CART_ON_PURCHASE:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    case CHECKOUT_SET_ORGANIZATION_USER:
      return {
        ...state,
        payload: {
          ...state.payload,
          organizationUsers: payload,
        },
      };
    default:
      return state;
  }
};
